import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { l } from '@manychat/manyui'

import { contentManagementActions } from 'apps/cms/store'
import { FOLLOW_REPLY_CHANNEL } from 'apps/followReply/constants'
import { FollowReplyState } from 'apps/followReply/interfaces'
import { FLOW_NAME, getChannelState, NAMESPACE } from 'apps/followReply/store/constants'
import { alert } from 'common/core'
import { followReplyApi } from 'shared/api/requests/followReply'
import { createAsyncAction } from 'shared/lib/redux'

export const createFlow = createAsyncAction(`${NAMESPACE}/createFlow`, async (_, { dispatch }) => {
  const flowData = await dispatch(
    contentManagementActions.createAutomation({
      name: FLOW_NAME,
    }),
  ).unwrap()

  if (!flowData) {
    alert(l.translate('Failed to create flow'))
    throw new Error('Failed to create follow reply flow')
  }

  const replacedFlowData = await followReplyApi.replaceFlow({
    body: { flow_ns: flowData.flow.ns },
  })

  return replacedFlowData.data
})

export const createFlowReducer = (builder: ActionReducerMapBuilder<FollowReplyState>) => {
  builder.addCase(createFlow.fulfilled, (state, action) => {
    const data = action.payload
    if (data) {
      state[FOLLOW_REPLY_CHANNEL] = getChannelState(data)
    }
  })
}
